import { AccessGuard, ForbiddenComponent, MyUserProfileComponent, SaveChangesGuard, UnauthorizedComponent, AppLayout } from "shared";
import { Routes } from '@angular/router';

import { HomeComponent } from "./home.component";

export const routes: Routes = [
  {path: '', component: AppLayout,
    children: [
      { path: "", pathMatch: "full", redirectTo: "home" },
      { path: "portal", pathMatch: "full", redirectTo: "home" },
      { path: "home", canActivate: [AccessGuard], data: { requiresLogin: true }, component: HomeComponent,
          children: [
            { path: "admin", canActivate: [AccessGuard], data: { requiresLogin: true }, loadChildren: () => import('./modules/admin/admin.routes').then(m => m.ADMIN_ROUTES) }
          ]},
      { path: "profile", canActivate: [AccessGuard], data: { requiresLogin: true }, component: MyUserProfileComponent, canDeactivate: [SaveChangesGuard] },
      { path: "forbidden", component: ForbiddenComponent },
      { path: "unauthorized", component: UnauthorizedComponent }
    ]
  }   
];
